import { Component, OnInit } from '@angular/core';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { AlertaExportarDialog } from '../dialogs/exportar-dialog/exportar-dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { AlterarPromocaoDemandaDialog } from '../dialogs/alterar-promocao-demanda-dialog/alterar-promocao-demanda-dialog';

@Component({
  selector: 'app-relatorio-promocoes-clientes',
  templateUrl: './relatorio-promocoes-clientes.component.html',
  styleUrls: ['./relatorio-promocoes-clientes.component.scss', '../../styles/estilo.padrao.scss']
})
export class RelatorioPromocoesClientesComponent implements OnInit {

  uid;
  tipoCadastro = 'Vendedor';
  bExportar: boolean = false;

  sBuscaRelatorio: any;
  aGruposPromocionais: any[] = [];
  aClientes: any[] = [];
  sIDAntigo: string = '';

  constructor(
    // private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private af: AngularFireAuth,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private router: Router,
  ) {
    this.uid = localStorage.getItem('uid');

    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.tipoCadastro = 'Vendedor';
      } else
        this.tipoCadastro = 'Admin';
    });
  }

  ngOnInit(): void {
    this.spinner.show('relatorio-promocoes-clientes');

    this.usuarioService.getGruposPromocoes().pipe(take(1)).subscribe(snap => {

      if (snap.length > 0) {
        let dados;
        let sAuxNomeProdutos = '';
        this.aGruposPromocionais = [];
        let auxGrupos = [];
        snap.forEach((item, index) => {
          dados = item.payload.val();

          sAuxNomeProdutos = '';
          for (let i = 0; i < dados.Produtos.length; i++) {
            sAuxNomeProdutos = sAuxNomeProdutos + dados.Produtos[i].Nome + '; ';
          }

          auxGrupos.push({ ID: item.key, Nome: dados.Nome, Produtos: dados.Produtos, QuantidadeMinima: dados.QuantidadeMinima, Status: dados.Status, NomeProdutos: sAuxNomeProdutos });
        });

        this.aGruposPromocionais = auxGrupos;

        this.sBuscaRelatorio = this.aGruposPromocionais[this.aGruposPromocionais.length - 1];
      }

      setTimeout(() => this.spinner.hide('relatorio-promocoes-clientes'), 800);
    });
  }

  gerarRelatorio() {

    this.spinner.show('relatorio-promocoes-clientes');

    this.usuarioService.getClientes().pipe(take(1)).subscribe(snap => {
      this.aClientes = [];
      this.sIDAntigo = this.sBuscaRelatorio.ID;

      let auxaClientes = [];
      if (snap.length > 0) {
        var dados;
        let auxQuantidadeMinima;
        let bGrupoPromocional;
        let auxDadosGrupoPromocional;
        let auxProcentagemDesconto;
        let auxIDGrupoPromocional;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          if (dados.GruposPromocionais) {
            bGrupoPromocional = false;
            Object.keys(dados.GruposPromocionais).forEach((key, index) => {
              auxDadosGrupoPromocional = dados.GruposPromocionais[key];
              if (auxDadosGrupoPromocional && auxDadosGrupoPromocional.IDGrupoDesconto === this.sBuscaRelatorio.ID) {
                auxIDGrupoPromocional = key;
                bGrupoPromocional = true;
                auxQuantidadeMinima = auxDadosGrupoPromocional.QuantidadeMinima;
                auxProcentagemDesconto = auxDadosGrupoPromocional.PorcentagemDesconto;
              }
            });

            if (bGrupoPromocional) {
              auxaClientes.push({
                IDCliente: item.key,
                Nome: dados.Nome,
                CidadeUF: dados.Cidade + '/' + dados.UF,
                IDVendedor: dados.IDVendedor,
                QuantidadeMinima: auxQuantidadeMinima,
                ProcentagemDesconto: auxProcentagemDesconto + '%', Status: 'Ativado',
                IDGrupoPromocional: auxIDGrupoPromocional
              });
            }
          }

        });

        this.aClientes = auxaClientes.sort((a, b) => a.Nome.localeCompare(b.Nome));

        this.bExportar = true;
      }
      setTimeout(() => this.spinner.hide('relatorio-promocoes-clientes'), 300);
    });
  }

  alterarSobDemanda() {
    const dialogRef = this.dialog.open(AlterarPromocaoDemandaDialog);
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        try {
          this.spinner.show('default');

          await Promise.all(this.aClientes.map(async (value) => {

            if (value.IDCliente) {
              return new Promise((resolve, reject) => {
                return this.usuarioService.updateTaxaPromocao(value.IDCliente, value.IDGrupoPromocional, result).then(resp => {
                  resolve(true);
                }).catch(e => {
                  reject(false);
                })
              })
            }

          })).then(resp => {

            this.toastr.success('Taxas atualizadas!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

            this.usuarioService.setLog("Alteração taxa de promoção em demanda: " + this.sBuscaRelatorio.ID + ' Nome: ' + this.sBuscaRelatorio.Nome, this.aClientes, this.uid);

            setTimeout(() => {
              this.spinner.hide('default');
              this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/relatorio-promocoes-clientes"]));
              this.toastr.clear();
            }, 800);
          });

        } catch (e) {
          console.log(e)
          this.spinner.hide('default');

          this.usuarioService.setLog("Erro ao altear taxa de promoção em demanda: " + this.sBuscaRelatorio.ID + ' Nome: ' + this.sBuscaRelatorio.Nome + ' Erro: ' + JSON.stringify(e), this.aClientes, this.uid);

          this.toastr.error('Erro ao alterar taxa sobre demanda!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
          setTimeout(() => {
            this.router.navigate(["/pages/relatorio-promocoes-clientes"]);
          }, 500);
        }
      } else {
        this.toastr.warning('É necessário especificar a taxa a ser aplicada', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
      }
    });
  }

  exportar() {
    const dialogRef = this.dialog.open(AlertaExportarDialog, {
      data: { bPDF: true, bExcel: false, bCSV: false },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imprimir(result.tipo)
      }
    });
  }

  imprimir(tipo) {
    var date = new Date();

    switch (tipo) {
      //PDF
      case 0:
        let doc = new jsPDF('l', 'mm', [297, 210]);
        let corpo: any = [];
        this.aClientes.forEach(dado => {
          var aux = [dado.Nome, dado.CidadeUF, dado.QuantidadeMinima, dado.ProcentagemDesconto, dado.Status];
          corpo.push(aux);
        });

        autoTable(doc, {
          head: [["Nome", "Cidade/UF", "Quantidade min.", "Desconto (%)", "Status"]],
          theme: 'grid',
          body: corpo,
          margin: { top: 10, right: 5, bottom: 10, left: 5 },
          showHead: 'firstPage',
          showFoot: 'lastPage',
          foot: [["Dados do grupo: " + this.sBuscaRelatorio.Nome, "", "Qnt. min. " + this.sBuscaRelatorio.QuantidadeMinima, "", "Status: " + (this.sBuscaRelatorio.Status ? 'Ativado' : 'Desativado')]]
        });
        doc.save('Relatório_de_promocoes_' + this.usuarioService.tratarData(date.getTime()) + '.pdf');

        this.usuarioService.setLog("Exportou relatório promoções em PDF. Data: " + this.usuarioService.tratarData(date.getTime()), null, this.uid);
        break;

      //Excel
      // case 1:
      //   this.excelService.exportAsExcelFile(this.produtos, 'Relatório_de_estoque_' + this.usuarioService.tratarData(date.getTime()));

      //   this.usuarioService.setLog("Exportou relatório de estoque em EXCEL. Data: " + this.usuarioService.tratarData(date.getTime()), null, this.uid);
      //   break;

      //CSV
      // case 2:
      //   var options = {
      //     fieldSeparator: ',',
      //     quoteStrings: '"',
      //     decimalseparator: '.',
      //     showLabels: true,
      //     showTitle: true,
      //     title: 'Relatório_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()),
      //     useBom: true,
      //     noDownload: false,
      //     headers: ["ID", "Status", "Bandeira cartão", "CEP", "Cidade", "Complemento", "Email", "Forma de pagamento", "IDVendedor", "Logradouro", "Nome", "Numero", "Observacao", "Referencia", "Status", "Status do pagamento", "Telefone", "Telefone secundário", "Total", "UF", "Data", "Hora", "Data da separação", "Hora da separação", "Data da rota", "Hora da rota", "Data da entrega", "Hora da entrega", "Data do cancelamento", "Hora do cancelamento", "Motivo do cancelamento", "Data e hora do pagamento"],
      //     nullToEmptyString: true,
      //   };

      //   new Angular5Csv(this.auxPedidos, 'Relatório_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), options);
      //   this.usuarioService.setLog("Exportou relatório de vendas em CSV. Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), map, this.uid);

      //   break;
    }
  }

}
